<template>
  <div class="container-fluid">
    <div class="alert alert-danger alert-margin" role="alert" v-if="isMessage">
      {{ message }}
    </div>
    <div id="title" class="row">
      <div class="col-1">
        <svg id="header" class="bd-placeholder-img mr-2 rounded" width="28" height="28" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: 32x32">
        <rect width="100%" height="100%" fill="#00C3E0"></rect>
        </svg>
      </div>
      <div class="col-5">
        <h5>組織・所属 変更一覧</h5>
      </div>
      <div class="col-3">
        <button id="createBtn" type="button" class="btn-sm btn-outline-info" v-on:click="create">新しく登録する</button>      
      </div>
    </div>
    <div id="main" class="row">
      <div class="col-1">
      </div>
      <div class="col-8">
        <table class="table table-dark table-sm table-hover">
          <thead>
            <tr>
              <th scope="col" style="width:70px">#</th>
              <th scope="col">開始日</th>
              <th scope="col">変更内容</th>
              <th scope="col" style="width:100px">状態</th>
              <th scope="col" style="width:150px">操作</th>
              <th scope="col" style="width:150px">確定/未確定</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(reserve, index) in reserves" v-bind:key="reserve.id">
              <th scope="row">{{ currentIndex * limit + index + 1 }}</th>
              <td>{{ reserve.startAt }}</td>
              <td>{{ reserve.operation }}</td>
              <td>{{ reserve.status }}</td>
              <td>
                <button v-if="reserve.statusValue === 0" type="button" class="btn-sm btn-light" v-on:click="modify(reserve.id)">編集する</button>
              </td>
              <td>
                <button v-if="reserve.statusValue === 0 && reserve.startAt > today" type="button" class="operationBtn btn-sm btn-light" v-on:click="fix(reserve.id,reserve.operationValue)">確定</button>
                <button v-if="reserve.statusValue === 1 && reserve.startAt > today" type="button" class="operationBtn btn-sm btn-light" v-on:click="not(reserve.id,reserve.operationValue)">未確定</button>
              </td>
            </tr>
          </tbody>
        </table>
        <nav aria-label="pager">
          <ul class="pagination justify-content-center">
            <li v-if="isPrev" v-on:click="goPrev">
              <a class="btn page-link rounded-pill">&larr; 前</a>
            </li>
            <li v-if="isPrev||isNext" class="mx-2">
              <a class="btn page-link rounded-pill">現在</a>
            </li>
            <li v-if="isNext" v-on:click="goNext">
              <a class="btn page-link rounded-pill">次 &rarr;</a>
            </li>
          </ul>
        </nav>
      </div>
      <div class="col-3">
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { sessions } from '../../mixin/session'
import { path } from '../../mixin/path'
import { headers } from '../../mixin/headers'

export default {
  name: 'List',
  mixins: [sessions,path,headers],
  props: ['realms'],
  data: function(){
    return {
      reserves: [],
      message: '',
      gridCount: 0,
      currentIndex: 0,
      limit: 20,
      today: ''
    }
  },
  created() {
    var curDate = this.today
    curDate = new Date();
    curDate.setDate(curDate.getDate());
    this.today = this.formatDate(curDate);
  },
  mounted() {
    this.getCurrent()
    if(this.$store.getters.hospital.id !== 0){
      this.search(true)
    }
    this.$store.watch(
      (state, getters) => getters.hospital,
      (newValue, oldValue) => {
        if (newValue.id != oldValue.id) {
          this.search(true)
        }
      }
    )
  },
  computed: {
    isNext: function () {
      return this.gridCount === this.limit
    },
    isPrev: function () {
      return this.currentIndex !== 0
    },
    isMessage: function () {
      return this.message.length > 0
    }
  },
  methods: {
    create() {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/reserve/create'))
    },
    modify(id) {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/reserve/modify/'+id))
    },
    search(isInit) {
      this.$cognito.isAuthenticated().then((session) => {
      if(session){
        if(isInit){
          this.currentIndex = 0
        }
        var offset = this.currentIndex * this.limit
        var accessToken = this.getAccessToken(this.$cognito,session)
        var hospitalId = this.$store.getters.hospital.id
        
        axios.get("/api/reserve/list" + "/" + hospitalId + "/" + offset,{
          headers: this.headers(accessToken)
        }).then(response => {
          this.reserves = response.data.data.reserves
          this.gridCount = this.reserves.length
        }).catch(err => {
          this.message = err.message
        })
      } else {
        this.$router.replace(this.replacePath(this.$cognito,this.realms,'/login'))
      }}).catch((err) => {
        this.message = err.message
      })
    },
    goNext(){
      this.currentIndex++
      this.search(false)
    },
    goPrev(){
      this.currentIndex--
      this.search(false)
    },
    fix(id, operation) {
      if (operation == 1) {
        this.updateOrganization(id,"/api/reserve/organization/fix")
      } else {
        this.updateStatus(id,1)
      }
    },
    not(id, operation) {
      if (operation == 1) {
        this.updateOrganization(id,"/api/reserve/organization/not")
      } else {
        this.updateStatus(id,0)
      }
    },
    updateOrganization(id,url) {
      this.$cognito.isAuthenticated().then((session) => {
      if(session){
        var accessToken = this.getAccessToken(this.$cognito,session)
        var hospitalId = this.$store.getters.hospital.id
        axios.put(url,{
          reserveId: id,
          hospitalId: hospitalId
        },{
          headers: this.headers(accessToken)
        }).then(response => {
          var res = response.data
          if(res.errorMessage) {
            this.message = res.errorMessage
          } else {
            alert('更新しました')
            this.search(false)
            this.message = ''
          }
        }).catch(err => {
          this.message = err.message
        })
      } else {
       this.$router.replace(this.replacePath(this.$cognito,this.realms,'/login'))
      }}).catch((err) => {
        this.message = err.message
      })
    },
    updateStatus(id,status) {
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          axios.put("/api/reserve/" + id, {
              reserve: {status: status}
          },{
            headers: this.headers(accessToken)
          }).then(response => {
            var res = response.data;
            if(res.errorMessage) {
              this.message = res.errorMessage
            } else {
              alert('更新しました')
              this.search(false)
              this.message = ''
            }
          }).catch(err => {
            this.message = err.message
          })
        }
      }).catch((err) => {
        this.message = err.message
      })
    },
    getCurrent() {
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          var hospitalId = this.$store.getters.hospital.id
          axios.get("/api/organization/management/current/" + hospitalId, {
            headers: this.headers(accessToken)
          }).then(response => {
            var data = response.data.data
            if(data){
              var organization = data.organization
              this.$store.commit('organization',{
                  startAt: organization.startAt,
                  historyId: organization.historyId
              })
            }
          }).catch(err => {
            throw err
          })
      } else {
        //this.$router.replace('/login') 
      }}).catch((err) => {
        this.message = err.message
      })
    },
    formatDate(curDate){
      var y = curDate.getFullYear();
      var m = ('00' + (curDate.getMonth()+1)).slice(-2);
      var d = ('00' + curDate.getDate()).slice(-2);
      var result = y +'-' + m + '-' + d;
      return result;
    },
  }
}
</script>

<style scoped>
#header {
  float: right;
}
#title {
  padding: 10px;
}
#main {
  height: 100%;
}
#createBtn {
  float:right;
}
.operationBtn {
  width: 70px;
}
.btn-sm{
  margin-left: 5px;
}
.search-solid{
  cursor: pointer;
  height: 18px;
  width: 18px;
}
.sort-solid{
  height: 25px;
  width: 25px;
  margin-right: 10px;
}
#sort-select{
  width: 70%;
}
.alert-margin{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
</style>